<template>
    <sweet-modal ref="umodal" width="800"  height="500">
        <div class="base">
            <div class="percent">
                %{{ percent }}
            </div>
            <h2 class="congrats-text"> Sport Cashback!</h2>
            <div class="button-area">
                <h1 class="amount"> <div id="betpot">0.00.0</div></h1>
                <a href="javascript:void();" @click="claimCashback()" class="Button-styles-button Button-styles-primary Button-styles-confirmation BalanceBox-styles-button BalanceBox-styles-desktop claim-button">{{ t.withdraw_now }}</a>
            </div>
        </div>
    </sweet-modal>
</template>

<script>
    import { CountUp } from 'countup.js';
    export default {
        name: 'cashbackPopup',
        data () {
            return {
                t: this.$root.t,
                cashback: 0,
                session: this.$parent.session,
                percent: 0
            }
        },
        mounted() {

            setTimeout(() => {
                this.fetchCashback()
            }, 500);
        },
        methods:{
            claimCashback () {
                this.$http.post(api + 'api/v2/cashback/sports').then(response => {
                    this.cashback = response.body.cashback

                    setTimeout(() => {
                        window.location.reload()
                    }, 1500);
                })
            },
            fetchCashback () {
                this.$http.get(api + 'api/v2/cashback/sports').then(response => {
                    //this.cashback = response.body.cashback

                    this.cashback = response.body.cashback
                    this.percent = response.body.percent

                    setTimeout(() => {

                        if (this.percent > 0 && this.cashback > 0)
                            this.$refs.umodal.open();

                        const options = {
                            startVal: this.cashback - ((10.8 / 100) * this.cashback),
                            duration: 2,
                            decimalPlaces: 2,
                        };
                        let demo = new CountUp('betpot', this.cashback, options);
                        if (!demo.error) {
                            demo.start();
                        } else {
                        }
                    }, 1500);
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Josefin+Sans:ital,wght@0,100..700;1,100..700&family=MuseoModerno:ital,wght@0,100..900;1,100..900&family=Oswald:wght@200..700&family=Pacifico&family=Ultra&family=VT323&display=swap');

.button-area {
    padding: 10px;
}
.claim-button {
    font-size: 34px;
    width: 100%;
    height: 2.4em !important;
    text-transform: uppercase;
}

.base {  
    padding-top: 15%;
    font-family: 'Ultra';
    height: 500px;
        background: url(/static/assets/img/confetti.svg) center center / cover;
      }
.percent {
    font-size: 14.8em;
    line-height: 0.6em;
    color: black;
}
.amount {
    background-color: black;
    border-radius: 10px;
    padding: 5% 0 5% 0;
    text-align: center;
    line-height:1em;
    color:#00c046;
    font-weight:bold;
    font-size: 4em;
    margin-bottom: 5%;
}
.congrats-text {
    font-size: 1.2em;
    background-color: white;
    position: relative;
    text-transform: uppercase;
    position: absolute;
    top: 18%;
    left: 0px;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/CashbackPopUp.vue